import { formAnatomy as t } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as o } from "@chakra-ui/react";
import { iconSizes as e } from "../../foundations/icons.mjs";
const { defineMultiStyleConfig: r } = o(t.keys), m = r({
  baseStyle: {
    container: {
      width: "100%",
      position: "relative",
      "span.label-optional": {
        textStyle: "bodySmall",
        lineHeight: "20px",
        color: "gray.600",
        pl: "2"
      }
    },
    requiredIndicator: {
      marginStart: 1,
      color: "red.500"
    },
    helperText: {
      textStyle: "bodySmall",
      mt: { base: 1, md: 2 },
      color: "gray.600",
      ".password-requirement-status-icon": {
        width: { base: e.sm, md: e.md },
        height: { base: e.sm, md: e.md }
      }
    }
  }
});
export {
  m as default
};
